module.exports = __webpack_public_path__ + "c5d1e2a6c95f973715cab57d77c00470.svg";